import { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { 
  Home, 
  TrendingUp, 
  AlertTriangle, 
  Zap, 
  Brain, 
  BarChart3, 
  Package, 
  Settings,
  MoreHorizontal
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DarkModeToggle } from './DarkModeToggle'
import { NetworkStatus } from './NetworkStatus'

interface LayoutProps {
  children: ReactNode
}

const navItems = [
  { path: '/', icon: Home, label: 'dashboard' },
  { path: '/predictions', icon: TrendingUp, label: 'predictions' },
  { path: '/risk', icon: AlertTriangle, label: 'risk' },
  { path: '/actions', icon: Zap, label: 'actions' },
  { path: '/intelligence', icon: Brain, label: 'intelligence' },
  { path: '/stability', icon: BarChart3, label: 'stability' },
  { path: '/kpi', icon: BarChart3, label: 'kpi' },
  { path: '/wholesale', icon: Package, label: 'wholesale' },
  { path: '/settings', icon: Settings, label: 'settings' },
]

export default function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <header className="bg-white shadow-sm sticky top-0 z-10" role="banner">
        <div className="mobile-container py-3 flex items-center justify-between">
          <h1 className="text-xl font-bold text-primary-600" aria-label="Kaching Global AI OS">
            Kaching
          </h1>
          <DarkModeToggle />
        </div>
      </header>
      <NetworkStatus />

      <main className="mobile-container py-4" role="main">
        {children}
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-10" role="navigation" aria-label="메인 네비게이션">
        <div className="flex justify-around items-center h-16">
          {navItems.slice(0, 4).map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center justify-center flex-1 h-full ${
                  isActive ? 'text-primary-600' : 'text-gray-500'
                }`}
                aria-label={t(item.label)}
                aria-current={isActive ? 'page' : undefined}
              >
                <Icon size={20} aria-hidden="true" />
                <span className="text-xs mt-1">{t(item.label)}</span>
              </Link>
            )
          })}
          <Link
            to="/settings"
            className={`flex flex-col items-center justify-center flex-1 h-full ${
              location.pathname === '/settings' ? 'text-primary-600' : 'text-gray-500'
            }`}
          >
            <MoreHorizontal size={20} />
            <span className="text-xs mt-1">더보기</span>
          </Link>
        </div>
      </nav>
    </div>
  )
}

